module.exports = __webpack_public_path__ + "img/mute.6a3f8afd.svg";